import { render } from "./VwTestCategoryColumnCard.vue?vue&type=template&id=6008ca41"
import script from "./VwTestCategoryColumnCard.vue?vue&type=script&lang=js"
export * from "./VwTestCategoryColumnCard.vue?vue&type=script&lang=js"

import "./VwTestCategoryColumnCard.vue?vue&type=style&index=0&id=6008ca41&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__